import { FieldNames } from 'Src/constants/FieldNames'

const fieldsOrder: FieldNames[] = [
	FieldNames.COMPANY_NAME,
	FieldNames.LAST_NAME,
	FieldNames.FIRST_NAME,
	FieldNames.MIDDLE_NAME,
	FieldNames.PHONE,
	FieldNames.EMAIL,
	FieldNames.REGION_ID,
	FieldNames.CITY_ID,
	FieldNames.MERCHANT_BRANCH_ID,
	FieldNames.NOTICE_NUMBER,
	FieldNames.ADD_INFO,
	FieldNames.CALL_ME,
	FieldNames.DEAL_AMOUNT,
	FieldNames.DEAL_SUBJECT_ID,
	FieldNames.ATTACHMENTS,
	FieldNames.RATE,
	FieldNames.SPECIAL_OFFER_ID,
	FieldNames.OTKRITIE_BANK_CITY,
]
const onlineFieldsOrder: FieldNames[] = [
	FieldNames.DECISION_MAKER_PERSON_NAME,
	FieldNames.DECISION_MAKER_PERSON_LAST_NAME,
	FieldNames.DECISION_MAKER_PERSON_FIRST_NAME,
	FieldNames.DECISION_MAKER_PERSON_MIDDLE_NAME,
	FieldNames.DECISION_MAKER_PHONE,
	FieldNames.DECISION_MAKER_EMAIL,
	FieldNames.FINANCE_PERSON_NAME,
	FieldNames.FINANCE_PERSON_EMAIL,
	FieldNames.MCC_CODE_ID,
	FieldNames.MCC_GROUP_ID,
	FieldNames.INSTALL_REGION_ID,
	FieldNames.INSTALL_DATE,
	FieldNames.POS_NAME,
	FieldNames.OPERATION_AVERAGE_SUM,
	FieldNames.TURN_OVER,
	FieldNames.QUESTIONS_CONTACT_PHONE,
	FieldNames.POSADDRESS,
	FieldNames.ORGADDRESS,
	FieldNames.ACCOUNT_NUMBER,
	FieldNames.ACCOUNT_BANK_BIC,
	FieldNames.MANAGER_NAME,
	FieldNames.MANAGER_LAST_NAME,
	FieldNames.MANAGER_FIRST_NAME,
	FieldNames.MANAGER_MIDDLE_NAME,
	FieldNames.MANAGER_PHONE,
	FieldNames.MANAGER_EMAIL,
	FieldNames.EQUIP_CONNECT_TYPE,
	FieldNames.EQUIP_TYPE,
	FieldNames.EQUIP_AMOUNT,
]
const onlineSalaryProjectFieldsOrder: FieldNames[] = [
	FieldNames.NUMBER_OF_EMPLOYEES,
	FieldNames.MONTHLY_SALARY,
]
export const fieldsOrders = {
	fieldsOrder,
	onlineFieldsOrder,
	onlineSalaryProjectFieldsOrder,
	allFields: [...fieldsOrder, ...onlineFieldsOrder, ...onlineSalaryProjectFieldsOrder],
}
